export var AddressSelectionMode;
(function (AddressSelectionMode) {
    // Unambiguous — assign the type directly
    AddressSelectionMode["Auto"] = "auto";
    // One address spans many networks of this type — user picks networks
    AddressSelectionMode["Networks"] = "networks";
    // Address format shared with other providers — user disambiguates the type (Starknet, Fuel)
    AddressSelectionMode["Overlap"] = "overlap";
})(AddressSelectionMode || (AddressSelectionMode = {}));
